<template>
    <div class="obj-list wrapper">
        <div class="page__card">
            <div class="page__card-title">
                <h1>{{ $t('reservoirs') }}</h1>
                <div class="page__card-item">
                    <router-link tag="button" to="/reservoir" class="page__card-router"
                        active-class="page__card-router--active" exact>
                        <IconBuilding4 class="router__icon" />
                        <p class="router__text">{{ $t('woter_base') }}</p>
                    </router-link>
                    <router-link tag="button" to="/reservoir/hydrounits" class="page__card-router"
                        active-class="page__card-router--active">
                        <IconCompany class="router__icon" />
                        <p class="router__text">{{ $t('hydrounits') }}</p>
                    </router-link>
                    <router-link tag="button" to="/reservoir/pumpingstations" class="page__card-router"
                        active-class="page__card-router--active">
                        <HMapLocation04 class="router__icon" />
                        <p class="router__text">{{ $t('pumpingstations') }}</p>
                    </router-link>
                    <router-link tag="button" to="/reservoir/hydroelectricpowerstations" class="page__card-router"
                        active-class="page__card-router--active">
                        <IconDam class="router__icon" />
                        <p class="router__text">{{ $t('hydroelectricpowerstations') }}</p>
                    </router-link>
                    <router-link tag="button" to="/reservoir/canals" class="page__card-router"
                        active-class="page__card-router--active">
                        <IconHydroBuilding class="router__icon" />
                        <p class="router__text">{{ $t('canals') }}</p>
                    </router-link>
                </div>
            </div>
            <div class="w-full " style="padding-bottom:20px;  ">
                <Canals v-if="$route.params.type == 'canals'" />
                <WaterBase v-if="$route.params.type == undefined" />
                <Hydrounits v-if="$route.params.type == 'hydrounits'" />
                <Hydroelectricpowerstations v-if="$route.params.type == 'hydroelectricpowerstations'" />
                <Pumpingstations v-if="$route.params.type == 'pumpingstations'" />
            </div>
        </div>
    </div>
</template>

<script>
import Canals from '@/components/Reservoir/Canals'
import WaterBase from '@/components/Reservoir/Water'
import Hydrounits from '@/components/Reservoir/Hydrounits'
import Hydroelectricpowerstations from '@/components/Reservoir/Hydroelectricpowerstations'
import Pumpingstations from '@/components/Reservoir/Pumpingstations'
import IconBridge1 from '../../components/Icons/iconBridge1.vue'
import IconBuilding4 from '../../components/Icons/iconBuilding4.vue'
import IconCompany from '../../components/Icons/iconCompany.vue'
import HMapLocation04 from '../../components/Icons/hMapLocation04.vue'
import IconDam from '../../components/Icons/iconDam.vue'
import IconHydroBuilding from '../../components/Icons/iconHydroBuilding.vue'
export default {
    components: {
        Canals,
        WaterBase,
        Hydrounits,
        Hydroelectricpowerstations,
        Pumpingstations,
        IconBridge1,
        IconBuilding4,
        IconCompany,
        HMapLocation04,
        IconDam,
        IconHydroBuilding
    },
    data() {
        return {
            type: 'woterbase'
        };
    },
    computed: {
        me() {
            return this.$store.state.me;
        },
        role() {
            return this.$store.state.role;
        },
    },
    mounted() {
        // if (this.$route.params.type == undefined) {
        //     this.$router.push('/reservoir/woterbase')
        // }
    }
}
</script>

<style lang="scss" scoped>
.ctatic-header {
    padding-bottom: 30px;
    padding-top: 20px;

}

.page__card-item {
    display: flex;
    flex-wrap: wrap;
    gap: 2px;
}

.page__card-router {
    padding: 8px 16px;
    border-radius: 12px;
    transition: all 0.3s ease;
    color: #1E293B;
    display: flex;
    align-items: center;
    gap: 8px;

    .router__text {
        font-weight: 600;
        line-height: 22px;
    }

    .router__icon {
        color: #0891B2;
        width: 24px;
        height: 24px;
    }

    &:hover {
        background: #F1F5F9;
    }

    &--active {
        background: #3730A3;
        color: white;

        &:hover {
            background: #4338CA;
        }

        .router__icon {
            color: white;
        }
    }
    @media screen and (max-width: 575px) {
        padding: 6px 10px;
        // width: 100%;
        .router__text{
            font-size: 14px;
            line-height: 1.375;
            text-align: start;
        }
    }
}
</style>
